module.exports = __webpack_public_path__ + "img/blockdit-3.03a072dd.svg";